/** DOM event the canvas page listens for to open the shader code editor. */
export const SHADER_OPEN_EDITOR_EVENT = 'genie:shader-open-editor'

/**
 * Ask the page to open the code editor for a shader node. A DOM event keeps
 * the node and the settings panel decoupled from page-level modal state.
 */
export function openShaderCodeEditor(nodeId: string): void {
  document.dispatchEvent(new CustomEvent(SHADER_OPEN_EDITOR_EVENT, { detail: { nodeId } }))
}
